import { render, staticRenderFns } from "./ProductGroup.vue?vue&type=template&id=14f9d7c6&scoped=true"
import script from "./ProductGroup.vue?vue&type=script&lang=js"
export * from "./ProductGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14f9d7c6",
  null
  
)

export default component.exports